import { render, staticRenderFns } from "./nav_iconB.vue?vue&type=template&id=29c4a4a2&scoped=true"
import script from "./nav_iconB.vue?vue&type=script&lang=js"
export * from "./nav_iconB.vue?vue&type=script&lang=js"
import style0 from "./nav_iconB.vue?vue&type=style&index=0&id=29c4a4a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c4a4a2",
  null
  
)

export default component.exports